import { render } from "./tab_restrictions.vue?vue&type=template&id=6ec46f0a"
import script from "./tab_restrictions.vue?vue&type=script&lang=js"
export * from "./tab_restrictions.vue?vue&type=script&lang=js"

import "./tab_restrictions.vue?vue&type=style&index=0&id=6ec46f0a&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__